import { Routes, Route } from 'react-router-dom';
import { Main } from '../Main/Main';
import WikiList from '../WikiList/WikiList.js';

const Wiki = ({
  activeLang,
  pathBread,
  currentArticle,
  setCurrentArticle,
  pathsWebName,
  setPathsWebName,
  description,
  setDescription,
  setPaths,
  paths,
}) => {
  return (
    <>
      {/* <ModalMiltilevelSidebarSettings /> */}

      <Routes>
        <Route
          path="/wiki-list/*"
          element={
            <WikiList
              isShowMain={true}
              activeLang={activeLang}
              pathBread={pathBread}
              currentArticle={currentArticle}
              setCurrentArticle={setCurrentArticle}
              pathsWebName={pathsWebName}
              setPathsWebName={(e) => setPathsWebName(e)}
              description={description}
              setDescription={(e) => setDescription(e)}
              setPaths={(e) => setPaths(e)}
              paths={paths}
            />
          }
        />
        <Route
          path="/*"
          element={
            <Main
              // readonly={false}
              isShowMain={true}
              activeLang={activeLang}
              pathBread={pathBread}
              currentArticle={currentArticle}
              setCurrentArticle={setCurrentArticle}
              pathsWebName={pathsWebName}
              setPathsWebName={(e) => setPathsWebName(e)}
              description={description}
              setDescription={(e) => setDescription(e)}
              setPaths={(e) => setPaths(e)}
              paths={paths}
            />
          }
        />
      </Routes>
    </>
  );
};

export { Wiki };
